import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { ListRequestQuery, WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_PAYEE_ENGAGEMENTS_LIST } from "../keys";
import { PayeeEngagementsAPIFilter } from "../../../services/payeeEngagement";
import {
  getAllPayeeEngagements,
  PayeeEngagementListResponse
} from "../../../services/payeeEngagement/getAllPayeeEngagements";

export const useQueryAllPayeeEngagements = (
  params?: ListRequestQuery<PayeeEngagementsAPIFilter>,
  config?: WSQueryConfig<PayeeEngagementListResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSQuery<PayeeEngagementListResponse, WSServiceError>(
    [QUERY_PAYEE_ENGAGEMENTS_LIST, params, xWingspanPayerId],
    async () => {
      return await getAllPayeeEngagements(xWingspanPayerId, params);
    },
    {
      ...config
    }
  );
};
